export enum Environments {
  STAGING = 'STAGING',
  PRODUCTION = 'PRODUCTION',
}
